import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import Detail from './Detail';
import DetailInbox from './DetailInbox';
import { useAuthUser } from '@crema/utility/AuthHooks';
import { onGetDetailDigisign, onChangeFilter } from 'redux/actions/DigitalSign';

// Kondisi sebelumnya => detail.state === 'done' && (detail?.receivers?.length > 0 && detail?.receivers.some(item => item.nip === user?.nip)) && filter !== 'sk-completed'

const DetailDokumen = ({ setRefresh }) => {
    const { user } = useAuthUser();
    const dispatch = useDispatch();
    const { id, type } = useParams();
    const { pathname, search } = useLocation();
    const queryParams = new URLSearchParams(search);

    const { detail, filter } = useSelector((state) => state.digiSign);

    useEffect(() => {
        if (id !== undefined && pathname === `/apps/dokumen-sk/detail/${type}/${id}`) {
            let filterParam = queryParams.get('filter')
            let monitoringRole = user?.roles_coofis.some(item => item.state === 'MONITORING_DIGITAL_SIGN')

            if (filterParam) {
                dispatch(onChangeFilter(filterParam))
            }
            dispatch(onGetDetailDigisign(id, monitoringRole));
        }
    }, [id]);

    return detail !== null ? (
        <>
            {filter !== 'sk-completed' ? (
                <Detail setRefresh={setRefresh} />
            ) : (
                <DetailInbox setRefresh={setRefresh} />
            )}
        </>
    ) : null
};

DetailDokumen.propTypes = {
    setRefresh: PropTypes.func,
};

export default DetailDokumen;
